const formatStringDate = date => {
  return new Date(date).toLocaleDateString('it-IT');
};

export { formatStringDate };
